import { render } from "./withAdminLayout.vue?vue&type=template&id=547432f0"
import script from "./withAdminLayout.vue?vue&type=script&lang=js"
export * from "./withAdminLayout.vue?vue&type=script&lang=js"

import "./withAdminLayout.vue?vue&type=style&index=0&id=547432f0&lang=css"
script.render = render

export default script